export const APP_NAME = "Quant Research Tool Hub";
export const APP_VERSION = "2.2.0";
export const SCHEMA_VERSION = 2;

export const CANONICAL_ROOT = ["Quantitative Finance", "Quant Research Tool Hub"];
export const CANONICAL_ROOT_LABEL = CANONICAL_ROOT.join("/");

export const GRAPH_SCOPES = [
  "User.Read",
  "Files.ReadWrite"
];

export const FOLDER_SPECS = [
  { key: "html", name: "HTML Tools", parent: "hub", category: "HTML Tools" },
  { key: "code", name: "Code", parent: "hub", category: null },
  { key: "csharp", name: "NinjaTrader C#", parent: "code", category: "NinjaTrader C#" },
  { key: "python", name: "Python", parent: "code", category: "Python" },
  { key: "data", name: "Data", parent: "hub", category: "Data" },
  { key: "trades", name: "Trade Logs", parent: "hub", category: "Trade Logs" },
  { key: "synthetic", name: "Synthetic Series", parent: "hub", category: "Synthetic Series" },
  { key: "metrics", name: "Metrics", parent: "hub", category: "Metrics" },
  { key: "reports", name: "Reports", parent: "hub", category: "Reports" },
  { key: "config", name: "Configurations", parent: "hub", category: "Configurations" },
  { key: "metadata", name: "_Hub Metadata", parent: "hub", category: null }
];

export const CONTENT_FOLDER_KEYS = FOLDER_SPECS.filter(x => x.category).map(x => x.key);
export const CATEGORY_OPTIONS = FOLDER_SPECS.filter(x => x.category).map(x => x.category);
export const CATEGORY_TO_FOLDER = Object.fromEntries(
  FOLDER_SPECS.filter(x => x.category).map(x => [x.category, x.key])
);
export const FOLDER_TO_CATEGORY = Object.fromEntries(
  FOLDER_SPECS.filter(x => x.category).map(x => [x.key, x.category])
);

export const DIRECT_UPLOAD_LIMIT = 20 * 1024 * 1024;
export const LARGE_FILE_WARNING = 200 * 1024 * 1024;
export const HASH_MEMORY_LIMIT = 200 * 1024 * 1024;
export const UPLOAD_CHUNK_SIZE = 10 * 1024 * 1024; // 32 × 320 KiB
export const TEXT_PREVIEW_LIMIT = 2 * 1024 * 1024;

export const CONFIG_FILENAME = "hub-config.json";
export const LIBRARY_FILENAME = "library.json";

export function extensionOf(name = "") {
  const match = String(name).toLowerCase().match(/\.([^.]+)$/);
  return match ? match[1] : "";
}

export function classifyFile(name = "") {
  const n = String(name).toLowerCase();
  const ext = extensionOf(n);

  if (/trade|tradelog|trade_log|fills?|orders?|executions?|pnl[_ -]?log/.test(n)) return "trades";
  if (/metric|performance|summary|stats?|equity|drawdown|mdd|walk.?forward|oos/.test(n)) return "metrics";
  if (/synthetic|feature|factor|transform|ecdf|zscore|z-score/.test(n)) return "synthetic";
  if (/report|memo|documentation/.test(n)) return "reports";

  if (["html", "htm"].includes(ext)) return "html";
  if (ext === "cs") return "csharp";
  if (["py", "ipynb", "r"].includes(ext)) return "python";
  if (["json", "yaml", "yml", "ini", "cfg", "toml", "xml"].includes(ext)) return "config";
  if (["md", "pdf", "doc", "docx", "txt"].includes(ext)) return "reports";
  return "data";
}

export function fileTypeLabel(name = "", mime = "") {
  const ext = extensionOf(name);
  if (["html", "htm"].includes(ext) || mime.includes("html")) return "HTML";
  if (ext === "cs") return "C#";
  if (ext === "py") return "PY";
  if (["csv", "tsv", "parquet", "json", "jsonl"].includes(ext)) return "DATA";
  if (["js", "ts", "jsx", "tsx", "css", "sql", "r", "ipynb"].includes(ext)) return "CODE";
  return (ext || "FILE").toUpperCase();
}

export function isTextLike(name = "", mime = "") {
  const ext = extensionOf(name);
  return mime.startsWith("text/") || [
    "html", "htm", "csv", "tsv", "json", "jsonl", "py", "cs", "js", "ts", "jsx", "tsx",
    "css", "md", "txt", "xml", "yaml", "yml", "ini", "cfg", "toml", "sql", "r"
  ].includes(ext);
}
